import { LOGIN_INFO } from './constants'
import React from 'react'
import styled from 'styled-components'

const LoginButtonStyle = styled.a`
  color: ${props => props.theme.v2.palette[ 'TAG1-700' ]};
  border: 1px solid ${props => props.theme.v2.palette[ 'TAG1-700' ]};
  text-align: center;
  font-size: 16px;
  line-height: 40px;
  font-weight: 700;
  border-radius: 8px;
  margin-right: 24px;
  height: 40px;
  width: 80px;

  @media (min-width: 992px) {
    width: 110px;
  }
`

const LoginButton = () => (
  <LoginButtonStyle
    className="login-button__desktop"
    href={ LOGIN_INFO.path }
  >
    { LOGIN_INFO.text }
  </LoginButtonStyle>
)

export default LoginButton
